<template>
  <div class="column">

    <div class="card dash-card headercard">
      <div class="card-header dash-card-header">
        <div style="height: 40px;"></div>
      </div>

      <!-- Cluster 6 -->
      <div class="card-body dash-card-body card-body-spacer">
        <bmwmtableitem :overallByWave="getOverallByWave"
                       :kpi="getKpiCustomerTreatment"
                       :isExtraNarrow="true"
                       :isHeader="true" />
        <titleunderline />

        <div class="dash-card-inner">
          <bmwmtableitem :kpi="getKpiRatingOfAppointmentMaking"
                         :overallByWave="getOverallByWave"
                         :hasStar="false"
                         :hasDashBorder="false" />

          <bmwmtableitem :kpi="getKpiRatingOfSalesConsultation"
                         :overallByWave="getOverallByWave"
                         :hasStar="false"
                         :hasDashBorder="false" />

          <bmwmtableitem :kpi="getKpiConsiderBuyingVehicle"
                         :overallByWave="getOverallByWave"
                         :hasStar="false"
                         :hasDashBorder="true" />

        </div>

      </div>
    </div>

    <RecommendationTable :recommend="getOverallRecommendation()"
                          :isCompetitionOverall="true"
                          :isHeaderRotated="true"
                          :title="getTextRecommend()"
                          :hasAsterisk="true"
                          :isBmwM="true"
                          :proHeader="getText('Promoters')"
                          :contraHeader="getText('Detractors')"
                          :neutralHeader="getText('Passives')" />

    <!-- Shops Count Stats -->
    <div class="card dash-card" id="shops">
      <div class="card-header dash-card-header" style="height: 30px; background: transparent; ">
        <h3 class="spacing">{{$t('Webportal.DashboardBMW.NumberOfShops')}} <span class="smalltext">({{$t('Webportal.DashboardBMW.Total')}} {{ getShops }})</span></h3>
      </div>
      <div class="card-body dash-card-body card-body-spacer">
        <ShopsOverallBMWM style="width: 100%;"
                          :overallValues="getOverallByWave"
                          :isCompetitionOverall="true" />
      </div>
    </div>

    <!-- Legende -->
    <LegendControl :workingStandardsText="getWorkingStandardGroup"
                   :successFactorsText="getSuccessFactorsGroup" />

  </div>

</template>


<script>
  import CustomKpiSorting from '@/mixins/CustomKpiSorting'

  import compareitem from './CompareItem'
  import bmwmtableitem from './BMWMTableItem.vue'
  import ShopsOverallBMWM from './ShopsOverallBMWM'
  import LegendControl from './LegendControl'
  import RecommendationTable from './RecommendationTable'
  import titleunderline from './TitleUnderline'
  import BrandMixin from '@/mixins/BrandMixin';

  export default {
    name: 'BMWMCustomerTreatmentColumn',

    mixins: [ BrandMixin, CustomKpiSorting ],

    components: {
      compareitem,
      bmwmtableitem,
      ShopsOverallBMWM,
      LegendControl,
      RecommendationTable,
      titleunderline
    },

    data() {
      return {
      }
    },

    props:[
      'dashdata',
      'isBmwM',
      'selectedBrand'
    ],

    methods:{
      getText(key) {
        return this.$t('Webportal.DashboardBMW.' + key)
      },

      getBrand() {
        if (this.isBmwM) return 'BMW M'
        if (this.getIsMini(this.selectedBrand)) { return 'MINI'; };
        if (this.getIsBMW(this.selectedBrand)) { return 'BMW'; };
        return 'BMW M'
      },

      getTextRecommend() {
        return this.$t('Webportal.DashboardBMW.Recommend') + ' ' + this.getBrand()
      },

      getOverallRecommendation() {
        if (!this.dashdata || !this.dashdata.Recommendation || _.size(this.dashdata.Recommendation) < 1)
          return;

        let rec = this.dashdata.Recommendation[0];
        if (rec.Tagged || !rec.SurveyWave) return rec;

        let bmwm = _.find(rec.SurveyWave, [ 'PropertyValue', 'BMW M']);
        _.remove(rec.SurveyWave, [ 'PropertyValue', 'BMW M']);
        let rest = rec.SurveyWave.slice(0);
        rec.SurveyWave = [];
        if (bmwm) rec.SurveyWave.push(bmwm);
        rest.forEach(item => { rec.SurveyWave.push(item); });
        rec.Tagged = true;
      },

      getKpiByString: function (name) {
        if (this.dashdata && this.dashdata.KPI && _.size(this.dashdata.KPI) > 0)
        {
          let item = _.find(this.dashdata.KPI, (x) => x.KpiCode === name)
          return this.getOrderedKpi(item)
        }
      },

      getKpiGroupByString: function (name) {
        if (this.dashdata && this.dashdata.KPIGroup && _.size(this.dashdata.KPIGroup) > 0)
        {
          let item = _.find(this.dashdata.KPIGroup, (x) => x.KpiCode === name)
          return this.getOrderedKpi(item)
        }
      },

      getOverallItem: function() {
        if (this.dashdata && this.dashdata.Overall && _.size(this.dashdata.Overall) > 0)
          return this.dashdata.Overall[0]
        return undefined
      },
    },

    computed: {

      getShops: function () {
        const item = this.getOverallItem()
        if (!item) { return '-' }
        return item.NumberOfShopsTotal
      },

      getOverallByWave: function() {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0)
          return this.dashdata.OverallByWave[0]
        return undefined
      },

      isNsc: function() {
        var _kpi = this.getKpiCustomerTreatment
        if (!_kpi || !_kpi.SurveyWave || _.size(_kpi.SurveyWave) === 0) {
          return false
        }
        var result = _kpi.SurveyWave[0].ResultNSC
        return result  != undefined
      },

      getKpiRatingOfAppointmentMaking: function() {
        return this.getKpiByString('6.1 Kundenorientierte Terminvereinbarung') // 6.1 Rating of appointment making') // 36/43 kpi
      },

      getKpiRatingOfSalesConsultation: function() {
        return this.getKpiByString('6.2 Beurteilung der Beratung') // 6.2 Rating of sales consulation') // 36/43 kpi
      },

      getKpiConsiderBuyingVehicle: function() {
        return this.getKpiByString('06. Kaufwahrscheinlichkeit des Fahrzeugs')
      },

      getKpiCustomerTreatmentName: function() {
        const item = this.getKpiGroupByString('Customer Treatment')
        if (item) { return item.KpiName }
        return '-'
      },

      getKpiCustomerTreatment: function() {
        return this.getKpiGroupByString('Customer Treatment')
      },

      getSuccessFactorsGroup: function() {
        let item = this.getKpiGroupByString('Success factors');
        return !item ? '-' : item.KpiName;
      },
      getWorkingStandardGroup: function() {
        let item = this.getKpiGroupByString('Working Standard');
        return !item ? '-' : item.KpiName;
      },
    }
  }

</script>

<style scoped>
.card-body-spacer {
  padding: 0px;
}
  .left {
      overflow: hidden;
      min-height: 26px;
  }

  .right {
      float: right;
      width: 83px;
      min-height: 26px;
  }

  .ctNoNsc {
    width: 95%;
    float: left;
    text-align: center;
    margin-top: 3px;
    margin-left: 6px;
    margin-right: 6px;
  }

  .hasnonsc{
    width: 100%;
  }

  .hasnsc{
     width: 65%;
  }

  .hasnonscitem{
    width: 0%;
  }

  .hasnscitem{
     width: 30%;
  }

  .p {
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    -o-hyphens: auto;
    hyphens: auto;
    word-wrap:break-word;
    text-overflow: ellipsis;
    text-overflow: unset;
  }

  .headercard{
    height: 310px;
  }


  .column{
    margin:0px;
    padding: 0px;
    min-height: 496px;
    position: relative;
    top: 0px;
    margin-block-end: 0px;
    margin-inline-end: 2px;
  }

  .nscHeader{
    min-height: 77px;
  }

  .noNscHeader{
    min-height: 60px;
  }

  h3{
    font-size: 10pt;
    margin: 0pt;
    text-align: center;
    font-stretch: extra-condensed;
    letter-spacing: -0.12em;
    white-space: normal;
    margin-top: 4px;
    font-weight: bold;
  }

.spacing{
  letter-spacing: unset;
}
</style>
